"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get default () {
        return syncMigration;
    },
    get syncBaseMigration () {
        return syncBaseMigration;
    }
});
const _KnexMigratorv2 = /*#__PURE__*/ _interop_require_default(require("~/db/sql-migrator/lib/KnexMigratorv2"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function syncMigration(base) {
    for (const source of (await base.getSources())){
        try {
            /* create sql-migrator */ const migrator = new _KnexMigratorv2.default({
                workspace_id: base.fk_workspace_id,
                base_id: base.id
            }, base);
            await migrator.init(source);
            /* sql-migrator : sync & up */ await migrator.sync(source);
            await migrator.migrationsUp({
                source
            });
        } catch (e) {
            console.log(e);
        // throw e;
        }
    }
}
async function syncBaseMigration(base, source) {
    try {
        /* create sql-migrator */ const migrator = new _KnexMigratorv2.default({
            workspace_id: base.fk_workspace_id,
            base_id: base.id
        }, base);
        await migrator.init(source);
        /* sql-migrator : sync & up */ await migrator.sync(source);
        await migrator.migrationsUp({
            source
        });
    } catch (e) {
        throw e;
    }
}
